module.exports = __webpack_public_path__ + "img/load-mobile.4b4defdd.jpg";